import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import ModalDialog from '../react/components/ModalDialog.jsx';

const FileDownload = props => {
    const [currentFile, setCurrentFile] = useState(props.Files.find(file => file.IsDefault) || props.Files[0]);
    const [modalOpen, setModalOpen] = useState(false);

    const units = props.units === false ? null : props.units || 'KB';
    const fileTitle = props.OverrideTitle ? props.OverrideTitle : currentFile.Title;

    const component = <>
        {!props.Modal && props.Files && props.Files.length > 1 && (
            <select className='content-item' value={currentFile.Url} autoComplete='off'
                onChange={event => setCurrentFile(props.Files.find(file => file.Url === event.target.value))}>
                {props.Files.map(language => (
                    <option key={language.Url} value={language.Url}>{language.Language}</option>
                ))}
            </select>
        )}
        {currentFile && <>
            <a className={`download-file ${props.GtmClasses}${props.Modal ? ' flex-container__expand' : ''}`} download={`${currentFile.Title}.${currentFile.Extension.toLowerCase()}`} href={currentFile.Url}>
                <span className='download-file__file-name' dangerouslySetInnerHTML={{__html: fileTitle}}></span>
                <span className='download-file__file-size'>{currentFile.Extension} {currentFile.Size > 0 && `(${currentFile.Size}${units && ` ${units}`})`} {currentFile.Language && ` – ${currentFile.Language}`}</span>
            </a>
            {props.Modal && props.Files && props.Files.length > 1 && <>
                <button type='button' className='download-file__modal-trigger' onClick={() => setModalOpen(true)}></button>
                <ModalDialog isOpen={modalOpen} header={fileTitle} width={600} onRequestClose={() => setModalOpen(false)}>
                    {props.Files.map(language => (
                        <FileDownload Files={[language]} key={language.Url} />
                    ))}
                </ModalDialog>
            </>}
        </>}
    </>;

    return <div className={`download-file-container ${props.Modal ? ' flex-container flex-container--no-gutter' : ''}`}
        data-initial-state={JSON.stringify(props)}>{component}</div>;
}

// Checks if the page contains any instances of this component and attaches to them as necessary.
export function init() {
    const instances = Array.from(document.querySelectorAll('.download-file-container[data-initial-state]'));
    for (const instance of instances) {
        // Don't hydrate if there's a parent FileDownload component
        if (!instance.parentElement.closest('.download-file-container[data-initial-state]')) {
            const props = JSON.parse(instance.dataset.initialState);
            ReactDOM.hydrate(React.createElement(FileDownload, props), instance.parentElement);
        }
    }
}

export default FileDownload;
